import { Reveal } from "@/components/Reveal";
import { PRIORITY_INDUSTRIES } from "@/data/industries";

export function IndustriesSection() {
  return (
    <section
      className="section-padding bg-background relative overflow-hidden"
      aria-labelledby="industries-heading"
    >
      <div className="absolute inset-0 grid-pattern opacity-20" />

      <div className="container-wide relative z-10">
        <Reveal className="max-w-3xl mx-auto text-center mb-10 sm:mb-12">
          <span className="section-badge mb-4">Industries Served</span>
          <h2
            id="industries-heading"
            className="heading-section text-foreground mt-4 mb-5 text-balance"
          >
            Built for trade and service businesses that{" "}
            <span className="heading-accent">compete locally</span>
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto leading-[1.7]">
            If you serve customers in a defined area and earn from jobs or
            bookings, our approach fits how your business wins work.
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 max-w-4xl mx-auto">
            {PRIORITY_INDUSTRIES.map((industry) => (
              <li
                key={industry}
                className="min-h-[60px] flex items-center justify-center text-center rounded-xl border border-border/60 bg-card shadow-card px-4 py-3.5 text-base font-semibold text-foreground/90"
              >
                {industry}
              </li>
            ))}
          </ul>
        </Reveal>

        <p className="text-center text-base text-muted-foreground mt-9 max-w-2xl mx-auto leading-[1.7]">
          Don’t see your industry? If you serve a local area, get in touch and
          we’ll tell you honestly whether we’re a good fit.
        </p>
      </div>
    </section>
  );
}
